export default __webpack_public_path__ + "static/media/c.7b9346c7.png";